import { FormTypes } from '@oneblink/types'

import { findElement, replaceElement } from '../../definition-manipulation'

function findLookupDiv(classState: string) {
  const elementDiv = document.querySelector(
    "[data-ob-name='fauxPricingLookupLoading__exclude']",
  )
  if (elementDiv) {
    return elementDiv.querySelector(`.ob-lookup__notification.${classState}`)
  }
}

function updateSpinnerHTML(definition: FormTypes.Form, html: string) {
  const fauxPricingLookupLoadingElement = findElement(
    definition,
    'fauxPricingLookupLoading__exclude',
  )
  if (
    fauxPricingLookupLoadingElement &&
    fauxPricingLookupLoadingElement.value.type === 'html' &&
    fauxPricingLookupLoadingElement.value.type !== html
  ) {
    fauxPricingLookupLoadingElement.parent.elements = replaceElement(
      fauxPricingLookupLoadingElement.parent.elements || [],
      fauxPricingLookupLoadingElement.value,
      {
        ...fauxPricingLookupLoadingElement.value,
        defaultValue: html,
        conditionallyShow: false,
      },
    )
  }
}

export function setSpinnerInitial(definition: FormTypes.Form) {
  updateSpinnerHTML(
    definition,
    '<div class="ob-lookup__notification loading-state"><div class="has-margin-top-7 has-text-centered notification"><div class="on-loading small"></div></div></div>',
  )
}

export function updateSpinnerState(
  liveSubmission: Record<string, unknown>,
  definition: FormTypes.Form,
) {
  if (liveSubmission.fauxPricingLookup__exclude) {
    setSpinnerLoading(definition)
    disableLookupChargesButton(
      !!liveSubmission.fauxPricingLookup__exclude,
      definition,
    )
  } else if (liveSubmission.hasPricingLookupRun__hidden === 'yes') {
    setSpinnerSuccess(definition)
    disableLookupChargesButton(false, definition)
  }

  return definition
}

async function setSpinnerLoading(definition: FormTypes.Form) {
  setSpinnerInitial(definition)

  await new Promise((resolve) => setTimeout(resolve, 0))

  const obLookupNotificationDiv = findLookupDiv('loading-state')
  if (obLookupNotificationDiv) {
    obLookupNotificationDiv.classList.add('is-looking-up')
  } else {
    //force it open
    updateSpinnerHTML(
      definition,
      '<div class="ob-lookup__notification is-looking-up"><div class="has-margin-top-7 has-text-centered notification"><div class="on-loading small"></div></div></div>',
    )
  }
}

async function setSpinnerSuccess(definition: FormTypes.Form) {
  const classState = 'success-state'

  updateSpinnerHTML(
    definition,
    `<div class="ob-lookup__notification is-looking-up ${classState}"><div class="notification has-margin-top-7 has-text-centered"><i class="material-icons has-text-success fade-in">check_circle_outline</i></div></div>`,
  )

  //this is how apps-react does it
  await new Promise((resolve) => setTimeout(resolve, 750))

  const obLookupNotificationDiv = findLookupDiv(classState)
  if (obLookupNotificationDiv) {
    obLookupNotificationDiv.classList.remove('is-looking-up')
  } else {
    //force it closed
    setSpinnerInitial(definition)
  }
}

export function setSpinnerError(
  definition: FormTypes.Form,
  errorMessage: string,
) {
  updateSpinnerHTML(
    definition,
    `<div class="ob-lookup__notification is-looking-up  is-extended">
      <div class="notification has-margin-top-7 has-text-centered">
        <div>
          <div>
            <i class="material-icons fade-in has-text-danger">error_outline</i>
            <p class="fade-in" ng-bind-html="$ctrl.obLookupCtrl.lookupErrorMessage">
              ${errorMessage}
            </p>
          </div>
        </div>
      </div>
    </div>`,
  )

  disableLookupChargesButton(false, definition)

  return definition
}

export function disableLookupChargesButton(
  isDisabled: boolean,
  definition: FormTypes.Form,
) {
  const chargesElement = findElement<FormTypes.RadioButtonElement>(
    definition,
    'fauxPricingLookup__exclude',
  )

  if (
    chargesElement &&
    chargesElement.parent &&
    chargesElement.parent.elements &&
    chargesElement.value
  ) {
    const disabledCharges: FormTypes.RadioButtonElement = {
      ...chargesElement.value,
      readOnly: isDisabled,
    }
    chargesElement.parent.elements = replaceElement(
      chargesElement.parent?.elements,
      chargesElement.value,
      disabledCharges,
    )
  }
}
